// ═══════════════════════════════════════════════════════════════════════════════
// Shared date/period display for settlement breakdown modals
// ═══════════════════════════════════════════════════════════════════════════════

/** YYYY-MM-DD */
export const isIsoDateYmd = (value: string): boolean => /^\d{4}-\d{2}-\d{2}$/.test(value);

/** When range start/end share the same calendar year, show MM-DD in daily breakdown tables. */
export const formatIsoDateForDailyBreakdownTable = (
  isoDate: string,
  rangeSameCalendarYear: boolean
): string => {
  const datePart = isoDate.length >= 10 ? isoDate.slice(0, 10) : isoDate;
  if (!rangeSameCalendarYear || !isIsoDateYmd(datePart)) {
    return isoDate;
  }
  return `${datePart.slice(5, 7)}-${datePart.slice(8, 10)}`;
};

export const formatSettlementPeriodDisplay = (
  startDate: string,
  endDate: string,
  t: (key: string, params?: Record<string, string | number>) => string
): string => {
  const rangeSameCalendarYear =
    isIsoDateYmd(startDate) &&
    isIsoDateYmd(endDate) &&
    startDate.slice(0, 4) === endDate.slice(0, 4);
  const displayStart = formatIsoDateForDailyBreakdownTable(startDate, rangeSameCalendarYear);
  const displayEnd = formatIsoDateForDailyBreakdownTable(endDate, rangeSameCalendarYear);
  if (startDate === endDate) {
    return displayStart;
  }
  return t('settlement.period', { start: displayStart, end: displayEnd });
};
